import { api } from ".";

export async function fetchTimeslotsByEventId(eventId:string) {
  const response = await api.get<Timeslot[]>("/timeslot", { params: { eventId }});

  return response.data;
}